import Al from "./Al";
import At from "./At";
import Ch from "./Ch";
import De from "./De";
import Es from "./Es";
import Fr from "./Fr";
import Gb from "./Gb";
import It from "./It";
import Us from "./Us";

const Flags = {
  al: <Al />,
  at: <At />,
  ch: <Ch />,
  de: <De />,
  en: <Gb />,
  es: <Es />,
  fr: <Fr />,
  gb: <Gb />,
  it: <It />,
  us: <Us />,
};

export default Flags;
